import {useId} from 'react';
import {PopupHint} from '@prtimes-basis/popup-hint';
import {HintIcon} from '@prtimes-basis/icons';
import {FormRow} from '../form-row';
import {contactPersonInfoFields} from '../../fields/contact-person-info';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function ContactPersonInformationSection() {
  const id = useId();
  const formTitleId = `${id}-formTitle`;

  return (
    <section
      aria-labelledby={formTitleId}
      className={companyRegistrationPageStyles.container}
    >
      <div className={companyRegistrationPageStyles.header}>
        <h2
          className={companyRegistrationPageStyles.formTitle}
          id={formTitleId}
        >
          担当者情報
        </h2>

        <PopupHint
          content='ログイン担当者および弊社からのご連絡窓口になります'
          wrapperClassName={companyRegistrationPageStyles.popupHintOverride}
          defaultPosition={{vertical: 'top', horizontal: 'right'}}
        >
          <span className={companyRegistrationPageStyles.popupHintText}>
            代理店の方へ
          </span>
          <HintIcon variant='colored' />
        </PopupHint>
      </div>

      <div className={companyRegistrationPageStyles.rows}>
        <FormRow
          isRequired
          labelText='メールアドレス'
          htmlFor='contactPersonInfo.email'
        >
          <contactPersonInfoFields.emailField />
        </FormRow>

        <FormRow
          isRequired
          labelText='パスワード'
          htmlFor='contactPersonInfo.password'
        >
          <contactPersonInfoFields.passwordField />
        </FormRow>

        <FormRow
          isRequired
          labelText='パスワード再入力'
          htmlFor='contactPersonInfo.passwordConfirmation'
        >
          <contactPersonInfoFields.passwordConfirmField />
        </FormRow>

        <FormRow labelText='所属部署' htmlFor='contactPersonInfo.department'>
          <contactPersonInfoFields.departmentField />
        </FormRow>

        <FormRow isRequired labelText='氏名'>
          <contactPersonInfoFields.nameField />
        </FormRow>

        <FormRow isRequired labelText='氏名（カナ）'>
          <contactPersonInfoFields.nameKanaField />
        </FormRow>

        <FormRow isRequired labelText='電話番号'>
          <contactPersonInfoFields.phoneNumberField />
        </FormRow>

        <FormRow labelText='FAX'>
          <contactPersonInfoFields.faxField />
        </FormRow>
      </div>
    </section>
  );
}
